import React, { Component } from 'react';
import fire from "../../components/firebase";
import $                    from 'jquery';
import datalist from "datalist-polyfill";


// CSS
import './style.css';

// IMG
import imgLogo  from "../../assets/logo.png";
import imgLogo2 from "../../assets/logo2.png";

import imgDown from "../../assets/down.png";

import imgSearch  from "../../assets/search.png";


import imgCountry   from "../../assets/country2.png";
import imgActivity  from "../../assets/activity4.png";
import imgTest  from "../../assets/test.png";



class Dashboard extends Component {
    
    
    constructor(props) {

        super(props);

        this.state = {

            list: [],
            listCountry: [],
            listActivity: [],
            listResult: [],

            btnShow: "Show all",

            country: "",
            activity: "",

            notFound: "",
            
            biography:"",
            company: "",
            country:"",
            firstname:"",
            lastname:"",
            picture: "",
            position: "",
            sector: "",
            website: ""
        }

        this.liveCountry    = this.liveCountry.bind(this);
        this.liveActivity   = this.liveActivity.bind(this);

        this.goUp           = this.goUp.bind(this);  
        
        this.openDetails    = this.openDetails.bind(this);
        this.closeDetails   = this.closeDetails.bind(this);
        
        this.showList       = this.showList.bind(this);
        this.subString      = this.subString.bind(this);
        
    }
    


    /* ********************************** LIVE CHANGE ********************************** */
    /* ********************************** LIVE CHANGE ********************************** */
    /* ********************************** LIVE CHANGE ********************************** */

    /* ************ COUNTRY ************ */
    /* ************ COUNTRY ************ */
    /* ************ COUNTRY ************ */
    liveCountry (e) {

        this.setState({country: e.target.value}, () => {if(this.state.country !== "" || this.state.activity !== "") {this.setState({btnShow: "Find your investor"})} else {this.setState({btnShow: "Show All"})}});
    }



    /* ************ ACTIVITY ************ */
    /* ************ ACTIVITY ************ */
    /* ************ ACTIVITY ************ */
    liveActivity (e) {

        this.setState({activity: e.target.value}, () => {if(this.state.country !== "" || this.state.activity !== "") {this.setState({btnShow: "Find your investor"})} else {this.setState({btnShow: "Show All"})}});
    }






    goUp () {

        $("html").animate({scrollTop: $("#dashboard .result").offset().top}, 1000);
    }



    openDetails (biography, company, country, firstname, lastname, picture, position, sector, website, logo) {

        $("#dashboard .details").css("visibility", "visible");
        $("body").css("overflow", "hidden");

        this.setState({
            biography:  biography,
            company:    company,
            country:    country,
            firstname:  firstname,
            lastname:   lastname,
            picture:    picture,
            position:   position,
            sector:     sector,
            website:    website,
            logo:       logo
        })

    }

    closeDetails () {

        $("#dashboard .details").css("visibility", "hidden");
        $("body").css("overflow-y", "scroll");

        this.setState({

            biography:          "",
            company:            "",
            firstname:          "",
            lastname:           "",
            picture:            "",
            position:           "",
            sector:             "",
            website:            "",
            logo:               ""
        })

    }





    /* ********************************** SHOW LIST ********************************** */
    /* ********************************** SHOW LIST ********************************** */
    /* ********************************** SHOW LIST ********************************** */
    showList () {

        this.setState({listResult: []});
        var list = [];
        var bool = false;

        
		$("html").animate({scrollTop: $("#dashboard .result").offset().top}, 1000);

 
        if (this.state.country !== "" && this.state.activity !== "") {

            for (var i = 0; i < this.state.list.length; i++) {

                if (this.state.list[i].country.indexOf(this.state.country) > -1 && this.state.list[i].sector.indexOf(this.state.activity) > -1) {

                    list.push(this.state.list[i]);
                    this.setState({ listResult: list});
                    bool = true;
                    $("#dashboard .result .list .notFound").hide(0);
                }                
            }

            if (bool === false) {

                $("#dashboard .result .list .notFound").show(0);
                this.setState({ notFound: "Nothing found for '" + this.state.country + "' and '" + this.state.activity + "'"});
            }

        } else if (this.state.country !== "" && this.state.activity === "") {

            for (var i = 0; i < this.state.list.length; i++) {

                if (this.state.list[i].country.indexOf(this.state.country) > -1) {

                    list.push(this.state.list[i]);
                    this.setState({ listResult: list});
                    bool = true;
                    $("#dashboard .result .list .notFound").hide(0);
                }
            }

            if (bool === false) {

                $("#dashboard .result .list .notFound").show(0);
                this.setState({ notFound: "Nothing found for '" + this.state.country + "'"});
            }

        } else if (this.state.country === "" && this.state.activity !== "") {

            for (var i = 0; i < this.state.list.length; i++) {

                if (this.state.list[i].sector.indexOf(this.state.activity) > -1) {

                    list.push(this.state.list[i]);
                    this.setState({ listResult: list});
                    bool = true;
                    $("#dashboard .result .list .notFound").hide(0);
                }
            }

            if (bool === false) {

                $("#dashboard .result .list .notFound").show(0);
                this.setState({ notFound: "Nothing found for '" + this.state.activity + "'"});
            }

        } else {

            // $("#dashboard .result .list .notFound").show(0);
            // this.setState({ notFound: "Please add a country and/or an activity area"});

            $("#dashboard .result .list .notFound").hide(0);
            this.setState({ listResult: this.state.list});
        }

    }




    subString(text) {

        if (text.length > 30) {

            text = text.substr(0,30) + "...";
        }

        return text;
    }






    // ********************************** REGISTER LIST **********************************
    // ********************************** REGISTER LIST **********************************
    // ********************************** REGISTER LIST **********************************
    componentDidMount()
    {



        $(document).keypress( (e) => {
            
            if (e.which == 13) 
            {
                this.showList();
            }
        });



        $("#dashboard .result .list .notFound").show(0);
        this.setState({ notFound: "Please add a country and/or an activity area"});

    
        var list = [];
        var listCountry = [];
        var listActivity = [];
        						
		if (sessionStorage.getItem("islamica500_list")) {

            list = JSON.parse(sessionStorage.getItem("islamica500_list"));
            listCountry = JSON.parse(sessionStorage.getItem("islamica500_listCountry"));
            listActivity = JSON.parse(sessionStorage.getItem("islamica500_listActivity"));

            this.setState({
                list: list,
                listCountry: listCountry,
                listActivity: listActivity
            });
            
		} else {   
            
            sessionStorage.setItem("islamica500_list", "");
            list  = this.state.list.slice();

            var query = fire.database().ref("/");
            var storage = fire.storage();


            

        // Create a storage reference from our storage service
        


        

            query.once("value").then( (snapshot) =>
            {
                snapshot.forEach( (childSnapshot) =>
                {
                    var firstname   = childSnapshot.child("Firstname").val();
                    var lastname    = childSnapshot.child("Lastname").val(); 
                    var company     = childSnapshot.child("Company").val(); 
                    var country     = childSnapshot.child("Country").val(); 
                    var position    = childSnapshot.child("Position").val(); 
                    var sector      = childSnapshot.child("Sector").val(); 
                    var website     = childSnapshot.child("Website").val(); 
                    var biography   = childSnapshot.child("Biography").val(); 
                    var picture     = childSnapshot.child("PictureProfil").val(); 
                    var logo        = childSnapshot.child("PictureCompany").val(); 

                    
                    // Add link Firestore to Users
                    /*
                    var picturRef   = storage.ref("Company/" + childSnapshot.child("Logo").val() + ".png");
                    picturRef.getDownloadURL().then( (url) => {
                        
                        childSnapshot.ref.update({ PictureCompany: url});
                    });
                    */
                    
                    if (country === "UK" || country === "uk") {

                        country = "United Kingdom";

                    } else if (country === "USA" || country === "usa") {

                        country = "United States";

                    } else if (country === "UAE" || country === "uae") {

                        country = "United Arab Emirates";
                    }
                    
                    list.push({ 

                        firstname: firstname, 
                        lastname: lastname,
                        company: company,
                        country: country,
                        position: position,
                        sector: sector,
                        website: website,
                        picture: picture,
                        logo: logo,
                        biography: biography
                    });
                    
                
                    
                    

                });

                this.setState({ list: list}, () => {sessionStorage["islamica500_list"] = JSON.stringify(list)});

                
                /* ************** COUNTRIES ************** */
                /* ************** COUNTRIES ************** */
                /* ************** COUNTRIES ************** */
                $.each(list, function(i) {

                    if ($.inArray(list[i].country, listCountry) === -1) {
                        listCountry.push(list[i].country);
                    }
                });

                this.setState({listCountry: listCountry.sort()}, () => {sessionStorage["islamica500_listCountry"] = JSON.stringify(listCountry)});



                /* ************** ACTIVITY ************** */
                /* ************** ACTIVITY ************** */
                /* ************** ACTIVITY ************** */
                $.each(list, function(i){
                    if ($.inArray(list[i].sector, listActivity) === -1) {
                        listActivity.push(list[i].sector);
                    }
                });

                this.setState({listActivity: listActivity.sort()}, () => {sessionStorage["islamica500_listActivity"] = JSON.stringify(listActivity)});

                
            });

            
        }



        var div1 = $("#dashboard .wallpaper").outerHeight();

        $(window).scroll( () =>
        {
            if ($("html").scrollTop() <= (div1 - 100)) {
                
                $("#dashboard .logo2").css("visibility", "hidden");
                //$("#dashboard .signature span").css("visibility", "hidden");
            }
            else {
                $("#dashboard .logo2").css("visibility", "visible");
                //$("#dashboard .signature span").css("visibility", "visible");
            }

            /*
            if ($("html").scrollTop() <= (div1 + 70)) {
                
                $("#dashboard .signature p").css("visibility", "hidden");
            }
            else {
                $("#dashboard .signature p").css("visibility", "visible");
            }
            */
        });

        
    }






   render() {

        return (
        
            <div id="dashboard">
            
                {/* *********************************** LOGO *********************************** */}
                {/* *********************************** LOGO *********************************** */}
                {/* *********************************** LOGO *********************************** */}
                <div className="triangle">
                    <img className="logo" src={imgLogo} alt="logo"/>
                </div>
                
                <img className="logo1" src={imgLogo2} alt="logo" onClick={() => {window.open("https://www.isfin.net/","_blank");}}/>
                <img className="logo2" src={imgLogo} alt="logo" onClick={this.goUp}/>


                {/* *********************************** WALLPAPER *********************************** */}
                {/* *********************************** WALLPAPER *********************************** */}
                {/* *********************************** WALLPAPER *********************************** */}
                <div className="wallpaper">
                

                    {/* ********************* SEARCH ********************* */}
                    {/* ********************* SEARCH ********************* */}
                    {/* ********************* SEARCH ********************* */}
                    <div className="search">

                        <p>Find The Global Leader</p>

                        <div className="center">

                            <input type="text" id="country"     list="listCountry"    placeholder="Country" onChange={this.liveCountry} value={this.state.country}/>
                            <datalist id="listCountry">
                            {this.state.listCountry.map((i, index) =>
                                <option key={index} value={i}/>
                            )}
                            </datalist>

                            <input type="text" id="activity"    list="listActivity"    placeholder="Activity Area" onChange={this.liveActivity} value={this.state.activity}/>
                            <datalist id="listActivity">
                            {this.state.listActivity.map((i, index) =>
                                <option key={index} value={i}/>
                            )}
                            </datalist>
                            
                            <div className="confirm" onClick={this.showList}><img src={imgSearch} alt="search"/></div>
                        </div>
                    </div>

                    <img src={imgDown} alt="down" id="down" onClick={this.goUp}/>
                
                </div>



                
                



                {/* *********************************** RESULT *********************************** */}
                {/* *********************************** RESULT *********************************** */}
                {/* *********************************** RESULT *********************************** */}
                <div className="result">



                    {/* ********************* SEARCH ********************* */}
                    {/* ********************* SEARCH ********************* */}
                    {/* ********************* SEARCH ********************* */}
                    <div className="searchbar">

                        <p className="title">Find the perfect investor</p>

                        <div className="center">

                            <label>Search by country</label>
                            <input type="text" id="country" list="listCountry"    placeholder="Country" onChange={this.liveCountry} value={this.state.country}/>

                            <label>Search by activity area</label>
                            <input type="text" id="activity" list="listActivity"   placeholder="Activity Area" onChange={this.liveActivity} value={this.state.activity}/>

                            <div className="confirm" onClick={this.showList}><img src={imgSearch} alt="search"/><p>{this.state.btnShow}</p></div>
                        </div>
                    </div>




                    {/* ********************* LIST ********************* */}
                    {/* ********************* LIST ********************* */}
                    {/* ********************* LIST ********************* */}
                    <div className="list">

                        <p className="notFound">{this.state.notFound}</p>
                        
                        {this.state.listResult.map((i, index) =>
                        <div className="item" id="a1" key={index} onClick={() => {this.openDetails(i.biography, i.company, i.country, i.firstname, i.lastname, i.picture, i.position, i.sector, i.website, i.logo)}}>

                             {/* ********** LEFT ********** */}
                             {/* ********** LEFT ********** */}
                             {/* ********** LEFT ********** */}
                            <div className="left" style={{ backgroundImage: `url(${i.picture})` }}></div>



                             {/* ********** CENTER ********** */}
                             {/* ********** CENTER ********** */}
                             {/* ********** CENTER ********** */}
                            <div className="center">

                                <div className="top">
                                    <p className="firstname">{i.firstname + " " + i.lastname}</p>
                                    <p className="lastname">{i.company}</p>
                                </div>

                                <hr/>

                                <div className="bottom">

                                    <div className="part">
                                        <p className="title">Country</p>
                                        <p className="text">{i.country}</p>
                                    </div>

                                    <div className="part">
                                        <p className="title">Activity Area</p>
                                        <p className="text">{i.sector}</p>
                                    </div>

                                    <div className="part">
                                        <p className="title">Position</p>
                                        <p className="text">{this.subString(i.position)}</p>
                                    </div>
                                    
                                </div>
                            </div>


                            {/* ********** RIGHT ********** */}
                            {/* ********** RIGHT ********** */}
                            {/* ********** RIGHT ********** */}
                            {
                                i.logo ? <img className="right" src={i.logo} alt="test"/> : <p className="right">{i.company}</p>
                            }
                            

                        </div>
                        )}

                    </div>

                </div>
                



                {/* *********************************** FOOTER *********************************** */}
                {/* *********************************** FOOTER *********************************** */}
                {/* *********************************** FOOTER *********************************** */}
                <div className="details">
                            
                    <div className="div">

                        <div className="left">
                        {/* <div className="left" style={{ backgroundImage: `url(${this.state.picture})` }}> */}
                        
                            <img src={this.state.picture}/>
                        </div>



                        <div className="center">

                            <p className="close" onClick={this.closeDetails}>X</p>

                            <div className="info">

                                <div className="top">
                                    <p className="firstname">{this.state.firstname + " " + this.state.lastname}</p>
                                    <p className="lastname">{this.state.company}</p>
                                </div>

                                <hr/>

                                <div className="bottom">

                                    <div className="part">
                                        <p className="title">Country</p>
                                        <p className="text">{this.state.country}</p>
                                    </div>

                                    <div className="part">
                                        <p className="title">Activity Area</p>
                                        <p className="text">{this.state.sector}</p>
                                    </div>

                                    <div className="part">
                                        <p className="title">Position</p>
                                        <p className="text">{this.state.position}</p>
                                    </div>
                                    
                                </div>
                            </div>


                            <p className="biography">
                                {this.state.biography}
                            </p>

                            <div className="company">

                                <div className="website">
                                    <p>Website</p>
                                    <a onClick={() => {window.open(this.state.website,"_blank");}}>{this.state.website}</a>
                                </div>

                                {/* { this.state.logo ? <img className="right" src={this.state.logo} alt="logo"/> : <p className="right">{this.state.company}</p> } */}

                                <img className="right" src={this.state.logo} alt="logo"/>
                            </div>

                        </div>

                    </div>

                </div>





                {/* *********************************** FOOTER *********************************** */}
                {/* *********************************** FOOTER *********************************** */}
                {/* *********************************** FOOTER *********************************** */}
                <div className="options">
                    <div className="signature">
                        <p>Designed and Developed by</p><span onClick={() => {window.open("http://az-consulting.co/","_blank");}}></span>
                    </div>
                </div>
                

            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.js